import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { environment } from '../../../environments/environment';
import { MaterialModule } from '../../material/material/material.module';
import { Router } from '@angular/router';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { AsyncPipe } from '@angular/common';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ClientSelectionService } from '../clients/client-selection.service';
import { NavigationService } from '../../services/navigation.service';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-navigation',
  standalone: false,
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.css',
  template: '<button (click)="goToNavigation()">Go to Navigation</button>',
  animations: [
    trigger('slideDown', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-50px)' }),
        animate(
          '500ms ease-out',
          style({ opacity: 1, transform: 'translateY(0)' }),
        ),
      ]),
      transition(':leave', [
        animate(
          '500ms ease-in',
          style({ opacity: 0, transform: 'translateY(-50px)' }),
        ),
      ]),
    ]),
  ],
})
export class NavigationComponent implements OnDestroy {
  isClientSelected = false;
  private subscription: Subscription;

  constructor(
    private router: Router,
    private clientService: ClientSelectionService,
    private navigationService: NavigationService,
  ) {
    this.subscription = this.clientService.selectedClient$.subscribe(
      (client) => {
        this.isClientSelected = !!client;
      },
    );
  }

  isMenuExpanded = true;
  menuItems = [
    { icon: 'home', text: 'Home' },
    { icon: 'supervisor_account', text: 'User Administrators' },
    { icon: 'notifications', text: 'Notifications' },
    { icon: 'link', text: 'RRE Linking' },
    { icon: 'person_search', text: 'Recovery Agents' },
    { icon: 'manage_accounts', text: 'RRE Management' },
    { icon: 'group', text: 'TPA RRE Management' },
    { icon: 'cloud_upload', text: 'Data Load Management' },
    { icon: 'build', text: 'QA Tools' },
    { icon: 'support_agent', text: 'Service Management' },
    { icon: 'swap_horiz', text: 'Claim Reassignment' },
    { icon: 'assignment_ind', text: 'Adjuster Management' },
    { icon: 'api', text: 'API Request/Response Info' },
    { icon: 'hub', text: 'Rest API Request/Response Details' },
  ].filter(
    (item) =>
      !(environment.artifactenv === 'production' && item.text === 'QA Tools'),
  );

  // Shown when no client is selected
  noClientMenuItems = [
    { icon: 'home', text: 'Home' },
    { icon: 'cloud_sync', text: 'SFTP Migration Config' },
    { icon: 'description', text: 'SFTP File Movement Logs' },
  ];

  toggleMenu() {
    this.isMenuExpanded = !this.isMenuExpanded;
    this.navigationService.setMenuExpanded(this.isMenuExpanded);
  }

  onMenuItemClick(menuItem: any) {
    this.navigationService.setSelectedMenuItem(menuItem.text);
  }

  isactiveleftmenu(): boolean {
    // Logic to return true or false
    return true; // or some condition
  }

  goToNavigation() {
    this.router.navigate(['/navigation']);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
